import moment from "moment";
import {
    Table,
    Tab,
    Header,
} from "semantic-ui-react";

const TabExperience = ({ datos, userState, handleOpenModal, handleCloseModal }: any) => {
    console.log(userState)
    const TabExperienciaFormal = () => {
        return (

            <Table
                columns={7}
                compact
                unstackable
                fixed
                singleLine
                striped
                size="small"
                className="border-right-left-none border-bottom-none"
            >
                <Table.Header fullWidth>
                    <Table.Row>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={1}
                        >
                            No.
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={2}
                        >
                            Nombre entidad
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={2}
                        >
                            Fecha de inicio
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={2}
                        >
                            Fecha de terminación
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={2}
                        >
                            Cargo/Rol desempeñado
                        </Table.HeaderCell>
                        {userState && (
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Anexo
                            </Table.HeaderCell>
                        )}

                    </Table.Row>
                </Table.Header>
                {datos?.experiencias_profesionales ? (
                    <Table.Body style={{ height: "100%" }}>
                        {datos.experiencias_profesionales.map((datos: any, index: number) => (
                            <Table.Row key={datos.nombre + datos.cargo}>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={1}
                                >
                                    {index + 1}
                                </Table.Cell>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={3}
                                >
                                    {datos.nombre}
                                </Table.Cell>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={2}
                                >
                                    {moment(datos.fecha_inicio).format('DD/MM/YYYY')}
                                </Table.Cell>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={1}
                                >
                                    {moment(datos.fecha_terminacion).format('DD/MM/YYYY')}
                                </Table.Cell>
                                <Table.Cell
                                    width={1}
                                    className="font-size-12px font-family-Work-Sans"
                                >
                                    {datos.cargo}
                                </Table.Cell>
                                {userState && (
                                    <Table.Cell
                                        width={1}
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        <button type="button" onClick={() => handleOpenModal(datos.documento)}> Ver Anexo</button>
                                    </Table.Cell>
                                )}
                            </Table.Row>
                        ))}
                    </Table.Body>
                ) : <Header>No tiene experiencia</Header>}
            </Table>

        );
    };
    const TabExperienciaJurado = () => {
        return (

            <Table
                columns={7}
                fixed
                singleLine
                compact
                unstackable
                striped
                size="small"
                className="border-right-left-none border-bottom-none"
            >
                <Table.Header fullWidth>
                    <Table.Row>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={1}
                        >
                            No.
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={3}
                        >
                            Nombre convocatoria
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={2}
                        >
                            Entidad
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={1}
                        >
                            Ciudad
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={1}
                        >
                            Año
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            className="background-color-FFFFFF font-size-12px"
                            width={1}
                        >
                            Área
                        </Table.HeaderCell>
                        {userState && (
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Anexo
                            </Table.HeaderCell>
                        )}


                    </Table.Row>
                </Table.Header>
                {datos?.experiencias ? (
                    <Table.Body style={{ height: "100%" }}>
                        {datos.experiencias.map((datos: any, index: number) => (
                            <Table.Row key={datos.nombre + datos.cargo}>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={1}
                                >
                                    {index + 1}
                                </Table.Cell>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={3}
                                >
                                    {datos.nombre_convocatoria}
                                </Table.Cell>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={2}
                                >
                                    {datos.entidad}
                                </Table.Cell>
                                <Table.Cell
                                    className="font-size-12px font-family-Work-Sans"
                                    width={1}
                                >
                                    {datos.ciudad}
                                </Table.Cell>
                                <Table.Cell
                                    width={1}
                                    className="font-size-12px font-family-Work-Sans"
                                >
                                    {datos.anio}
                                </Table.Cell>
                                <Table.Cell
                                    width={1}
                                    className="font-size-12px font-family-Work-Sans"
                                >
                                    {datos.area}
                                </Table.Cell>
                                {userState && (
                                    <Table.Cell
                                        width={1}
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        <button type="button" onClick={() => handleOpenModal(datos.documento)}>ver Anexo</button>
                                    </Table.Cell>
                                )}

                            </Table.Row>
                        ))}
                    </Table.Body>
                ) : (
                    <Header>No tiene experiencia</Header>
                )}
            </Table>

        );
    };
    const experienciaPanes = [
        {
            menuItem: "Experiencia profesional",
            render: () => (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                    <TabExperienciaFormal />
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Experiencia en formulación, ejecución y evaluación de proyectos",
            render: () => (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                    {" "}
                    <TabExperienciaJurado />
                </Tab.Pane>
            ),
        },
    ];
    const ExperienciaTabs = () => (
        <Tab
            panes={experienciaPanes}
            menu={{ secondary: true, pointing: true }}
            className="tabs-jurados"
            renderActiveOnly={true}
        />
    );
    return (
        <ExperienciaTabs />
    );
};


export default TabExperience

